export default "__VITE_ASSET__3728f7c4__"